import Grid from '@mui/material/Grid';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ASaveButton } from '../../../common/buttons';
import { ASwitch } from '../../../common/inputs';
import { yearMonthDateTimeFormat } from '../../../core/constants';
import { IFormValidator } from '../../../core/FormValidator';
import { ResourceTextApplication } from '../../../core/resources';
import { ProductionPlanType } from '../../../interfaces/enums';
import { IPlanConfirmationData, IProductionPlan, IProductionPlanAccess } from '../../../interfaces/IProductionPlan';
import { useAppSelector } from '../../../store/hooks';

interface IProps {
    data: IPlanConfirmationData;
    setData: (data: IPlanConfirmationData) => void;
    access: IProductionPlanAccess;
    readonly?: boolean;
    validator: IFormValidator;
    onSave: () => void;
}

export default function Confirmation({ data, setData, access, readonly, validator, onSave }: IProps) {
    const { t } = useTranslation<ResourceTextApplication[]>([
        'AnelmaLayout',
        'AnelmaCattleProductionPlan',
    ]);
    const loginStatus = useAppSelector((state) => state.loginStatus.data);

    const now = () => {
        return `${moment().format(yearMonthDateTimeFormat)}Z`;
    };

    const [showConfirm] = useState<boolean>(
        data.Type == ProductionPlanType.Draft || data.Type == ProductionPlanType.Completed
    );

    const [showSaveWithoutConfirm] = useState<boolean>(data.Type == ProductionPlanType.Draft);

    const [showApprove] = useState<boolean>(
        access.IsAdmin &&
            (data.Type == ProductionPlanType.Completed || data.Type == ProductionPlanType.Approved)
    );

    const [saving, setSaving] = useState<boolean>(false);

    useEffect(() => {
        if (saving) {
            setSaving(false);
            onSave();
        }
    }, [data]);

    const setCreator = () => {
        setData({
            ...data,
            Creator: loginStatus.name,
            ValidFrom: now(),
            Type: ProductionPlanType.Draft,
        })
    };

    const setCreatorAndConfirmer = () => {
        setData({
            ...data,
            Creator: loginStatus.name,
            ValidFrom: now(),
            Confirmer: loginStatus.name,
            ConfirmedAt: now(),
            Type: ProductionPlanType.Completed,
        })
    };

    const setApprover = () => {
        setData({
            ...data,
            Approver: loginStatus.name,
            ApprovedAt: now(),
            Type: ProductionPlanType.Approved
        })
    };

    const onConfirm = () => {
        setSaving(true);
        setCreatorAndConfirmer();
    };

    const onSaveWithoutConfim = () => {
        setSaving(true);
        setCreator();
    };

    const onApprove = () => {
        setSaving(true);
        setApprover();
    };

    return (
        <Grid container direction='row' style={{ paddingLeft: 40 }}>
            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>

            </Grid>
            {!readonly && (
                <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                    {showConfirm && (
                        <ASaveButton onClick={onConfirm}>
                            {t('AnelmaCattleProductionPlan:1050')}
                        </ASaveButton>
                    )}
                    {showSaveWithoutConfirm && (
                        <ASaveButton onClick={onSaveWithoutConfim}>
                            {t('AnelmaCattleProductionPlan:1062')}
                        </ASaveButton>
                    )}
                    {showApprove && (
                        <ASaveButton onClick={onApprove}>
                            {t('AnelmaCattleProductionPlan:1051')}
                        </ASaveButton>
                    )}
                </Grid>
            )}
        </Grid>
    );
}
